import { Hero, About, JoinUs, FeaturedProjects, Lines, Partners} from '@components/Home/index'

function Home() {
  return (
    <>
    <Hero />
    <About />
    <JoinUs />
    <FeaturedProjects />
    <Lines />
    <Partners />
    </>
  );
}

export default Home;
